<template>
 <v-dialog
      v-model="$store.state.medicalHistoryDialog"
      persistent
      width="896px"
    >
      <v-card min-height="786px">
  
        <v-card-text>
           <v-container>
            <v-row>
            <!-- <v-avatar size="100px"> -->
              <v-col cols="2">
              <img
                alt="Avatar"
                :src="require('@/assets/image/Group 427323441.png')"
                width="100" height="100"
              />
              </v-col>
              <v-col cols="10">
                <h4>นางสาวสมพร ปราถนา</h4><br>รอชักประวัติ
              </v-col>
            <!-- </v-avatar> -->
          </v-row>
          <v-row>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>ส่วนสูง(cm.)<span style="color:red;">*</span></span>
              <v-text-field
                    v-model="data.height"
                    hide-details="auto"
                    placeholder="กรุณาระบุ"
                    solo
        
                  ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>นํ้าหนัก(kgs.)</span>
              <v-text-field
                    v-model="data.weight"
                    hide-details="auto"
                    placeholder="กรุณาระบุ"
                    solo
                    
                  ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>BMI</span>
              <v-text-field
                    v-model="data.bmi"
                    hide-details="auto"
                    placeholder=""
                    solo
                    disabled
                  ></v-text-field>
            </v-col>
             <v-col cols="3" class="d-flex flex-column mt-3">
              <span>อุณหภูมิ(C)</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="กรุณาระบุ"
                    solo
                  ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>PR(bpm.)<span style="color:red;">*</span></span>
              <v-text-field
                    hide-details="auto"
                    placeholder="อัตราการเต้นหัวใจ"
                    solo
                  ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>BP(Sys mmHg./DIA mmHg.)</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="กรุณาระบุ"
                    solo
                  ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>RR(/min)</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="อัตราการหายใจ"
                    solo
                  ></v-text-field>
            </v-col>
             <v-col cols="3" class="d-flex flex-column mt-3">
              <span>DTX (mg/dl.)</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="ระดับน้ำตาลในเลือด"
                    solo
                  ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>รอบเอว(cm.)<span style="color:red;">*</span></span>
              <v-text-field
                    hide-details="auto"
                    placeholder="กรุณาระบุ"
                    solo
                  ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>การตั้งครรภ์</span>
              <v-select
               placeholder="กรุณาเลือก"
              solo 
              v-model="data.pre" 
              :items="pregnant">
              </v-select>
            </v-col>
            <v-col cols="3" class="d-flex flex-column mt-3">
              <span>ดื่มแอลกอออล์</span>
              <v-select
              placeholder="กรุณาเลือก"
              solo 
              v-model="data.drink" 
              :items="drink"></v-select>
            </v-col>
             <v-col cols="3" class="d-flex flex-column mt-3">
              <span>สูบบุหรี่</span>
              <v-select
              placeholder="กรุณาเลือก"
              solo 
              v-model="data.smoking" 
              :items="smoking" ></v-select>
            </v-col>
          </v-row>
        <v-row>
          <v-col cols="2" class="text-align-start pl-0" style="color: #238ef2"
            >ข้อมูลผู้ป่วย</v-col
          >
          <v-col cols="10" class="card-margin">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row>
           <v-col cols="12" class="d-flex flex-column mt-3">
              <span>อาการปัจจุบัน</span>
              <v-textarea
                    hide-details="auto"
                    placeholder="กรุณากรอกอาการเบื้องต้น"
                    solo
                  ></v-textarea>
            </v-col>
        </v-row>
         <v-row>
           <v-col cols="6" class="d-flex flex-column mt-3">
              <span>ยาที่ใช้ประจำ</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="ไม่มี"
                    solo
                  ></v-text-field>
            </v-col>
            <v-col cols="6" class="d-flex flex-column mt-3">
              <span>แพ้ยา</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="ไม่แพ้"
                    solo
                  ></v-text-field>
            </v-col>
        </v-row>
         <v-row>
           <v-col cols="6" class="d-flex flex-column mt-3">
              <span>แพ้อาหาร</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="ไม่แพ้"
                    solo
                  ></v-text-field>
            </v-col>
            <v-col cols="6" class="d-flex flex-column mt-3">
              <span>ประวัติครอบครัว</span>
              <v-text-field
                    hide-details="auto"
                    placeholder="ไม่ระบุ"
                    solo
                  ></v-text-field>
            </v-col>
        </v-row>
        </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            color="blue darken-1"
            outlined
            style="padding-left: 50px;padding-right: 50px;"
            @click="$store.state.medicalHistoryDialog = false"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            color="blue darken-1"
            style="color: #ffffff;padding-left: 20px;padding-right: 20px;"
            @click="$store.state.medicalHistoryDialog = false"
          >
            ส่งเข้าพบแพทย์
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  // props: ['data'],
   data () {
    return {
      data: {
        height: '',
        weight: '',
        bmi: '',
        pre: null,
        drink: null,
        smoking: null
      },
      temp: 0,
      sum: 0,
      pregnant: [
       'ไม่ตั้งครรภ์',
        'ตั้งครรภ์'
      ],
      drink: [
        'ดื่ม',
        'ไม่ดื่ม'
      ],
      smoking: [
        'สูบ',
        'ไม่สูบ'
      ]
    }
  },
 
  watch: {
    'data.height' (e) {
      this.temp = e
    },
    'data.weight' (e) {
      this.sum = (parseInt(e) / ((parseInt(this.temp)/100)**2))
      this.data.bmi = isNaN(this.sum) ? '0' : this.sum.toFixed(2)
    }
  },
  methods: {
  
  }
}
</script>